import { Copy, Globe, MessageCircle, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const Row = ({ id, label, url, msg }: { id: string; label: string; url: string; msg: string }) => {
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success(`${label} copied`); };
  const wa = `https://wa.me/?text=${encodeURIComponent(`${msg} ${url}`)}`;
  return (
    <div className="flex flex-col gap-3 rounded-xl bg-slate-50 p-3 sm:flex-row sm:items-center" data-testid={`share-row-${id}`}>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold uppercase tracking-widest text-brand-slate">{label}</p>
        <a href={url} target="_blank" rel="noopener noreferrer" className="mt-0.5 inline-flex max-w-full items-center gap-1 truncate text-sm font-medium text-brand-blue hover:underline" data-testid={`share-link-${id}`}>
          <span className="truncate">{url}</span><ExternalLink className="h-3.5 w-3.5 shrink-0" />
        </a>
      </div>
      <div className="flex gap-2">
        <button onClick={copy} className="inline-flex items-center gap-1.5 rounded-full border border-brand-line bg-white px-3 py-1.5 text-xs font-semibold text-brand-navy transition hover:bg-slate-100" data-testid={`copy-${id}-button`}><Copy className="h-3.5 w-3.5" />Copy</button>
        <a href={wa} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] px-3 py-1.5 text-xs font-semibold text-white transition hover:opacity-90" data-testid={`whatsapp-${id}-button`}><MessageCircle className="h-3.5 w-3.5" />WhatsApp</a>
      </div>
    </div>
  );
};

export function ShareLinks() {
  const origin = window.location.origin;
  return (
    <article className="min-w-0 rounded-2xl border border-brand-line bg-white p-4 shadow-subtle sm:col-span-2 sm:p-5" data-testid="share-links-card">
      <p className="flex items-center gap-2 font-heading font-semibold text-brand-navy"><Globe className="h-4 w-4 text-brand-emerald" />Share Bhasa</p>
      <div className="mt-3 space-y-2">
        <Row id="live" label="Live website" url={origin} msg="Arrange trusted care for family in Zimbabwe with Bhasa Global Care Network:" />
        <Row id="install" label="Install app link" url={`${origin}/dashboard`} msg="Install the Bhasa Care app: sign in, then tap Download on your dashboard." />
      </div>
    </article>
  );
}
